import ApiService from '../common/api.service';

import {
  FETCH_DETALLE_AVISOS,

} from './actions.type';

import {
  SET_ERROR,
} from './mutations.type';

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
};

const getters = {

};

const actions = {
  [FETCH_DETALLE_AVISOS](context, params) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post(`accesos/avisos/${params.aviso_id}`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ data }) => {
          context.commit(SET_ERROR, [data.data.message]);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
